const schema = (contractTypes, contractStatuses, operationTypes, typeId) => ({
  type: 'object',
  required: ['title', 'forecast_amount', 'cost'],
  properties: {
    title: {
      type: 'string',
      title: 'contract_title',
    },
    forecast_amount: {
      type: 'string',
      title: 'forecast_amount',
    },
    cost: {
      type: 'string',
      title: 'contract_cost',
    },
    // status: {
    //   type: 'string',
    //   title: 'status',
    //   oneOf: contractStatuses,
    // },
    type_id: {
      type: 'string',
      title: 'contract_type',
      oneOf: contractTypes,
      default: '1',
    },
    category_id: {
      type: 'string',
      title: 'category',
    },
    operation_type_id: {
      type: 'string',
      title: 'operation_type',
      // oneOf: operationTypes,
    },
    // employer_type: {
    //   type: 'number',
    //   title: 'employer_type',
    //   oneOf: [
    //     { const: 0, title: 'natural' },
    //     { const: 1, title: 'legal' },
    //   ],
    //   default: 0,
    // },
    workshop_id: {
      type: 'string',
      title: 'workshop',
    },
    start_date: {
      type: 'string',
      title: 'start_date',
      format: 'date',
    },
    end_date: {
      type: 'string',
      title: 'end_date',
      format: 'date',
    },
    is_civil: {
      type: 'number',
      title: 'civil_project',
      oneOf: [
        { const: 1, title: 'yes' },
        { const: 0, title: 'no' },
      ],
    },
    number: {
      type: 'string',
      title: 'contract_number',
    },
    contractual_number: {
      type: 'string',
      title: 'contractual_number',
    },

    details: {
      type: 'string',
      title: 'details',
    },
    ...employerFields(typeId),
  },
});

const employerFields = (typeId) => {
  const selected = typeId == null || typeId === '' ? '1' : String(typeId);

  if (selected === '1' || selected === '2') {
    return {
      employer_id: {
        type: 'string',
        title: 'natural_employer',
      },
    };
  }

  if (selected === '3' || selected === '4') {
    return {
      company_id: {
        type: 'string',
        title: 'legal_employer',
      },
    };
  }

  return {};
};

export default schema;
